import React from "react";

export default function Splash(){
    return <div style={{
        height:'100%', width:'100%', minHeight:400,
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'center'
    }}>
        <div>
            <h3>Helpful Hints:</h3>
            <ul>
                <li>Search for ads that include all of the keywords by clicking “Exact Match"</li>
                <li>Exclude keyword(s) from your search by adding a minus sign before the keyword(s)</li>
                <li>For more search options click “More Filters”</li>
                <li>Remove a keyword or filter by clicking the “x” on any tag</li>
                <li>Customize your ad in Step 3</li>
                <li>View saved ads by clicking “Saved Presentations"</li>
                <li><span style={{fontWeight:'bolder'}}>For a Print and Digital package:</span>
                    <ol>
                        <li style={{marginTop: 10}}>Add keyword(s)</li>
                        <li>Choose “Print with Web”</li>
                        <li>Select the print ad in Step 2</li>
                        <li>Customize (optional) and save it in Step 3</li>
                        <li>Choose the Web ads in Step 3 using the “Ad Options” button</li>
                    </ol>
                </li>
            </ul>
        </div>
    </div>
}